<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-20 no-scrollbar">
    <div class="bg-white shadow-lg rounded p-4 max-w-md w-full relative">
        <h1 class="font-bold text-xl">{{title}}</h1>
        <p class="mt-1 text-primary-300 text-sm">{{description}}</p>
        <div class="my-4">
            @if (multiple) {
            @for (item of options; track $index) {
            <div class="flex flex-row justify-start content-center">
                <input type="checkbox" (change)="onChangeOption($event)" [value]="item"
                    [checked]="selectedOption.includes(item)"
                    class="rounded my-auto outline-none ring-0 focus:outline-none focus:ring-0">
                <a (click)="onTextSelection(item)" class="cursor-pointer ml-2 capitalize">{{item}}</a>
            </div>
            }
            } @else {
            <select (change)="onChangeOption($event)"
                class="border-0 px-2 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                @for (item of options; track $index) {
                <option [selected]="selectedOption.includes(item)">
                    {{item}}</option>
                }
            </select>
            }
        </div>
        <div class="flex flex-row gap-4 justify-end">
            <button type="button" (click)="onCancel()"
                class="text-primary-500 px-4 py-2 focus:outline-none">Cancel</button>
            <button (click)="submit()"
                class="bg-primary-500 text-white rounded font-semibold px-4 py-2 focus:outline-none">{{action}}</button>
        </div>
    </div>
</div>